const GroupedCategoryChangeEvents = {
  PAGE_LOADED: 'grouped-category-change-events-page-loaded',
  PRODUCT_SELECTED: 'grouped-category-change-events-product-selected',
};

export default GroupedCategoryChangeEvents;
